import { Injectable } from "@angular/core";
import { Observable, defer, switchMap } from "rxjs";
import { ServiceUtil } from "../utilities/service.util";
import { OidcSecurityService } from "angular-auth-oidc-client";
import DevExpress from 'devextreme/bundles/dx.all';

@Injectable()
export class AspDataStoreService {
    constructor(
        private _oidcSecurityService: OidcSecurityService,
        private _serviceUtil: ServiceUtil,
    ) { }

  getAspDataStoreWithToken(url:string): Observable<DevExpress.data.CustomStore> {
    return this._oidcSecurityService.getAccessToken().pipe(
        switchMap((token) => {
            return defer(() => this._serviceUtil.createASPDataStoreWithToken({ loadUrl: url },token));
        }));
  }
}